export default __webpack_public_path__ + "static/media/Cockatiel.1f8325f5.jpg";